import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import { Table } from "reactstrap";

const mapStateToProps = (state) => {

    return {
        getTutorDetail: state.TutorReducer.getTutorDetail,
    };
    
}; //END MAPSTATETOPROPS

class TutorDelete extends Component {


    render() {
        let isEmpty  = this.props.getTutorDetail.length === 0;
        let tutor    = Object.values(this.props.getTutorDetail);

        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>
                    <Col md="12">
                        <FormGroup>

                            <Table striped>
                                <tbody>


                                    {isEmpty ?
                                        <div>There are no results</div>
                                        :
                                        tutor.map(item =>
                                            <>
                                                <tr>
                                                    <td width="200">ID</td>
                                                    <td width="10">:</td>
                                                    <td>{item.idtutor}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Tipo</td>
                                                    <td width="10">:</td>
                                                    <td>{item.tipo}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Apellido Paterno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.apellidopaterno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Apellido Materno</td>
                                                    <td width="10">:</td>
                                                    <td>{item.apellidomaterno}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Nombres</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nombres}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Ocupación</td>
                                                    <td width="10">:</td>
                                                    <td>{item.ocupacion}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Trabaja En</td>
                                                    <td width="10">:</td>
                                                    <td>{item.trabajaen}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Teléfono</td>
                                                    <td width="10">:</td>
                                                    <td>{item.telefono}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Correo</td>
                                                    <td width="10">:</td>
                                                    <td>{item.correo}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Número Hijos</td>
                                                    <td width="10">:</td>
                                                    <td>{item.numerohijos}</td>
                                                </tr>

                                            </>
                                        )
                                    }

                                </tbody>
                            </Table>


                        </FormGroup>
                    </Col>
                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

TutorDelete = reduxForm({
    form: "formTutorDelete",
    enableReinitialize: true,
})(TutorDelete);
export default connect(mapStateToProps, null)(TutorDelete);
